var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160,0H96C84.218,0,74.667,9.551,74.667,21.333v21.333H32c-11.782,0-21.333,9.551-21.333,21.333v64 c0,11.782,9.551,21.333,21.333,21.333h42.667v213.333H32c-11.782,0-21.333,9.551-21.333,21.333v64 c0,11.782,9.551,21.333,21.333,21.333h42.667v21.333C74.667,502.449,84.218,512,96,512h64c11.782,0,21.333-9.551,21.333-21.333 V21.333C181.333,9.551,171.782,0,160,0z M53.333,106.667V85.333h21.333v21.333H53.333z M53.333,426.667v-21.333h21.333v21.333 H53.333z M138.667,469.333h-21.333V448v-64V128V64V42.667h21.333V469.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,0h-64c-11.782,0-21.333,9.551-21.333,21.333v469.333c0,11.782,9.551,21.333,21.333,21.333h64 c11.782,0,21.333-9.551,21.333-21.333V21.333C309.333,9.551,299.782,0,288,0z M266.667,469.333h-21.333V42.667h21.333V469.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,149.333c11.782,0,21.333-9.551,21.333-21.333V64c0-11.782-9.551-21.333-21.333-21.333h-42.667V21.333 C437.333,9.551,427.782,0,416,0h-64c-11.782,0-21.333,9.551-21.333,21.333v469.333c0,11.782,9.551,21.333,21.333,21.333h64 c11.782,0,21.333-9.551,21.333-21.333v-21.333H480c11.782,0,21.333-9.551,21.333-21.333v-64c0-11.782-9.551-21.333-21.333-21.333 h-42.667V149.333H480z M458.667,85.333v21.333h-21.333V85.333H458.667z M394.667,469.333h-21.333V42.667h21.333V64v64v256v64 V469.333z M458.667,405.333v21.333h-21.333v-21.333H458.667z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.e580272687f5e546e3183424f3c98e79.svg";
export { ForwardRef as ReactComponent };